<div>{{'history.event.resource-color-changed'|translate}}</div>
@for (link of event.details.links; track link) {
  <div>
    @if (!!link.nodeId) {
      <small>{{'history.event-block.node-title.0'|translate:prepareLink(link)}}
        <span [class.linkPart]="link.stillExists" (click)="browseToNode(link)">{{'history.event-block.node-title.1'|translate:prepareLink(link)}}</span>
        {{'history.event-block.node-title.2'|translate:prepareLink(link)}}
      </small>
    }
  </div>
}
